<template>
  <div class="current-task-box">
    <div class="font-weight-bold">{{ 'Current Task' | trans }}</div>

    <div class="d-flex gap-10px flex-column">

      <div class="current-task-btn" @click="openLast()">
        <div class="d-flex align-items-center gap-10px h-100">
          <div class="current-task-icon" v-bind:class="redoIconOuter">
            <i class="far lh-inherit" :class="redoIcon"></i>
          </div>
          <div class="current-task-text">
            {{currentJob.apiJob?.sat_links?.redo?.name}}
          </div>
        </div>
        <div><i class="far fa-arrow-right"></i></div>
      </div>

    <div class="d-flex gap-10px">
      <start-over-btn></start-over-btn>
      <change-options-btn v-if="currentJob.apiJob?.sat?.permissions?.can_continue === true"></change-options-btn>
    </div>
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'
import JobManager from "../../manager/JobManager";
import PreviewManager from "../../manager/PreviewManager";
import Reconvert from "../../util/Reconvert";
import {EventBus} from "../../events/event.bus";
import {EVENT_APP_NAVIGATE} from "../../events/app.events";
import StartOverBtn from "./StartOverBtn.vue";
import ChangeOptionsBtn from "./ChangeOptionsBtn.vue";
import Analytics from "../../util/Analytics";

export default {
  name: "CurrentTask",
  props: {},
  components: {ChangeOptionsBtn, StartOverBtn},
  mixins: [
    store,
    currentJob,
  ],
  data() {
    return {
    };
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    async openLast() {
      await Analytics.send('result_action', 'last_task', this.currentJob);

      window.location.href = this.currentJob.apiJob.sat_links.redo.href.link;
    },
    getSingleSelectedFilename() {
      let output =  this.getOutputById(this.currentJob.id, this.selectedOutputs[0]);
      return PreviewManager.getFilenameFromOutput(output);
    },
    openContinue(operation) {
      if (this.complete && this.selectedOutputs.length > 0) {
        Reconvert.continueWithSelected(this.currentJob, operation);
      }
    },
  },
  computed: {
    redoIcon() {
      if (this.currentJob.apiJob !== null) {
        return `far ${this.currentJob.apiJob.sat_links?.redo?.icon} lh-inherit text-main-${this.currentJob.apiJob.sat_links?.redo?.color}-reverse`;
      }
      return '';
    },
    redoIconOuter() {
      if (this.currentJob.apiJob !== null) {
        return `bg-main-${this.currentJob.apiJob.sat_links?.redo?.color}`;
      }
      return '';
    },
    reconvertLinks() {
      return Reconvert.getReconvertList(this.currentJob);
    }
  }
};
</script>
<style lang="scss" scoped>
.current-task-icon {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  border-radius: 4px;
  color: white;
}
.current-task-btn {
  overflow:hidden;
  display: flex;
  background: #F8F9FA;
  border: 1px solid #CBCBCB;
  border-radius: 4px;
  justify-content: space-between;
  padding: 5px 20px 5px 5px;
  height: 42px;
  align-items: center;
  cursor: pointer;

  .dark-mode & {
    background:#383838;;
    border: 1px solid #595959;
    color: white;
    &:hover {
      background: #323232;
    }
  }

  &:hover {
    background: #F2F2F2;
  }

  .continue-btn-text {
    display: flex;
    gap: 10px;
    align-items: center;
  }
}
.alert {
  font-size: 12px;
  padding: 5px 5px;
  margin: 0;
}
.current-task-box {
  display: flex;
  flex-direction:column;
  gap: 20px;
}

.disabled {
  opacity: .5;
  cursor: not-allowed !important;
}
.current-task-item {
  border-radius: 4px;
  padding: 0 10px 0 0;
  cursor: pointer;
  border: 1px solid transparent;

  &:hover {
    background: #F2F2F2;
    border: 1px solid #CBCBCB;
  }
}

.continue-btn {
  display: flex;
  background: #F8F9FA;
  border: 1px solid #CBCBCB;
  border-radius: 4px;
  justify-content: space-between;
  padding: 10px 20px;
  align-items: center;
  cursor: pointer;

  .dark-mode & {
    background:#383838;;
    border: 1px solid #595959;
    color: white;
    &:hover {
      background: #323232;
    }
  }



  &:hover {
    background: #F2F2F2;
  }

  .current-task-text {
    display: flex;
    gap: 10px;
    align-items: center;
  }
}
</style>
